import React, { Component } from "react";
import ReactDOM from "react-dom";

import bgDesktop from "../../assets/images/Pantalla_Instructiva/pantalla_horizontal.png";
import bgMobile from "../../assets/images/Pantalla_Instructiva/pantalla_vertical.png";
import medalla from "../../assets/images/Pantalla_Instructiva/medalla_M.png";
import jugar from "../../assets/images/Pantalla_Instructiva/boton_jugar.png";
import jugar2 from "../../assets/images/Pantalla_Instructiva/boton_jugar_presionado.png";
import parlante from "../../assets/images/Pantalla_Instructiva/boton_sonido";
import musica2 from "../../assets/sound/narracion/musica2.mp3";
import initAudio from "../../assets/sound/narracion/INICIA JUEGO.mp3";
import finalAudio from "../../assets/sound/narracion/FINAL NIÑOS.mp3";
import finalAudioPodios from "../../assets/sound/narracion/PODIOS 2 y 3.mp3";
import "./App.css";
import click from "../../assets/sound/fx/click2.mp3";

import Juego_1 from "./Juego_1";

const musics = [musica2];
// let music_index = Math.floor(Math.random() * (2 - 0) + 0);
const music = new Audio(musics[0]);
const init_audio = new Audio(initAudio);
const final_audio = new Audio(finalAudio);
const final_audio_podios = new Audio(finalAudioPodios);

export default class Inicio extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hover: false,
    };
    this.setButton = this.setButton.bind(this);
    this.repetirAudio = this.repetirAudio.bind(this);
    this.Iniciar = this.Iniciar.bind(this);
  }

  componentDidMount() {
    this.props.instrucciones.play();
    this.props.instrucciones.addEventListener("ended", () => {
      this.props.instrucciones.currenTime = 0;
      this.props.instrucciones.play();
    });
  }

  Iniciar() {
    // ReactGA.event({
    //   category: "leB",
    //   action: "FfleB",
    // });

    this.props.instrucciones.pause();
    this.props.instrucciones.currentTime = 0;

    let audio = new Audio(click);
    audio.play();

    music.play();
    music.pause();
    init_audio.play();
    init_audio.pause();
    final_audio.play();
    final_audio.pause();
    final_audio_podios.play();
    final_audio_podios.pause();

    setTimeout(function () {
      // let newValor = value;
      const element = (
        <Juego_1
          music={music}
          init_audio={init_audio}
          final_audio={final_audio}
          final_audio_podios={final_audio_podios}
        />
      );
      ReactDOM.render(element, document.getElementById("root"));
    }, 500);
  }

  repetirAudio() {
    this.props.instrucciones.pause();
    this.props.instrucciones.currentTime = 0;
    this.props.instrucciones.play();
  }

  setButton() {
    let hover = !this.state.hover;
    this.setState({ hover });
    console.log(hover);
  }

  render() {
    return (
      <div className="instructiveBackground0">
        <div className="instructiveBackground1">
          <div
            style={{
              position: "relative",
              textAlign: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {/* {(window.innerWidth > 480) &
            (window.innerWidth / window.innerHeight > 1) ? (
              <div>
                <img
                  src={bgDesktop}
                  className="instruction-background-image"
                  alt="background"
                />{" "}
              </div>
            ) : (
              <div>
                <img
                  src={bgMobile}
                  className="instruction-background-image"
                  alt="background"
                />{" "}
              </div>
            )} */}
            <div>
              <img src={medalla} className="medalla_inicial" alt="Medalla" />
            </div>
            <div
              onMouseDown={() => this.setState({ hover: true })}
              onMouseUp={this.Iniciar}
            >
              {!this.state.hover ? (
                <img src={jugar} className="boton_jugar" alt="Jugar" />
              ) : (
                <img src={jugar2} className="boton_jugar" alt="Jugar" />
              )}
            </div>
            <div>
              <img
                src={parlante}
                onClick={this.repetirAudio}
                className="parlante"
                alt="Parlante"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
